import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { Textarea } from "../../ui/textarea";
import { Button } from "../../ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../../ui/select";
import { DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../../ui/dialog";
import { EVENT_TYPE_OPTIONS } from "./eventTypes";

export const EventForm = ({ form, setForm, editingId, saving, onSubmit, onCancel }) => (
  <>
    <DialogHeader>
      <DialogTitle>{editingId ? "Editar evento" : "Nuevo evento"}</DialogTitle>
      <DialogDescription>
        Completa los datos del evento para agendarlo en tu calendario.
      </DialogDescription>
    </DialogHeader>
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
      className="space-y-4"
    >
      <div>
        <Label>Tipo de evento</Label>
        <Select value={form.event_type} onValueChange={(v) => setForm({ ...form, event_type: v })}>
          <SelectTrigger data-testid="event-form-type" className="mt-1">
            <SelectValue placeholder="Selecciona un tipo" />
          </SelectTrigger>
          <SelectContent>
            {EVENT_TYPE_OPTIONS.map((opt) => (
              <SelectItem key={opt.value} value={opt.value} data-testid={`event-form-type-option-${opt.value}`}>
                {opt.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="grid grid-cols-3 gap-3">
        <div className="col-span-1">
          <Label>Fecha</Label>
          <Input
            data-testid="event-form-date"
            type="date"
            value={form.date}
            onChange={(e) => setForm({ ...form, date: e.target.value })}
            className="mt-1"
            required
          />
        </div>
        <div>
          <Label>Hora inicio</Label>
          <Input
            data-testid="event-form-start-time"
            type="time"
            value={form.start_time}
            onChange={(e) => setForm({ ...form, start_time: e.target.value })}
            className="mt-1"
            required
          />
        </div>
        <div>
          <Label>Hora fin</Label>
          <Input
            data-testid="event-form-end-time"
            type="time"
            value={form.end_time}
            onChange={(e) => setForm({ ...form, end_time: e.target.value })}
            className="mt-1"
            required
          />
        </div>
      </div>

      <div>
        <Label>Nombre del cliente</Label>
        <Input
          data-testid="event-form-client-name"
          value={form.client_name}
          onChange={(e) => setForm({ ...form, client_name: e.target.value })}
          className="mt-1"
          required
        />
      </div>

      <div>
        <Label>Notas adicionales</Label>
        <Textarea
          data-testid="event-form-notes"
          value={form.notes}
          onChange={(e) => setForm({ ...form, notes: e.target.value })}
          className="mt-1"
          rows={3}
        />
      </div>

      <DialogFooter className="gap-2">
        <Button type="button" variant="outline" onClick={onCancel} data-testid="event-form-cancel">
          Cancelar
        </Button>
        <Button type="submit" disabled={saving} data-testid="event-form-submit">
          {saving ? "Guardando..." : editingId ? "Guardar cambios" : "Crear evento"}
        </Button>
      </DialogFooter>
    </form>
  </>
);
